import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    display: 'block',
    height: '400px',
  },
  fullScreenContainer: {
    width: '100vw',
    height: '100vh',
    padding: '97px 38px 38px 38px',
    boxSizing: 'border-box',
  },
  fullScreenHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '77px',
    width: '100%',
    padding: '29px 40px 22px 40px',
    borderBottom: `1px solid ${theme.palette.grey.grey100}`,
  },
  fullScreenHeaderTitle: {
    fontSize: '22px',
    lineHeight: '120%',
    fontWeight: 600,
    letterSpacing: '-0.22px',
    marginLeft: '4px'
  },
  fullScreenHeaderContextName: {
    fontSize: '18px',
    lineHeight: '0',
    marginLeft: '5px'
  },
  fullScreenHeaderClose: {
    marginLeft: 'auto',
    cursor: 'pointer',
  }
}));

export default useStyles;
